import { ReactNode, useMemo, useState } from 'react';
import BundlingDataContext from '@raas/shared/src/features/bundling/contexts/BundlingDataContext';
import type { BundlingDataContextContract } from '@raas/shared/src/features/bundling/contexts/BundlingDataContext';
import type { BundlingContract } from '@raas/shared/src/features/bundling/contracts/bundling.type';

type BundlingContextProviderProps = {
  children: ReactNode;
};

export function BundlingContextProvider({ children }: BundlingContextProviderProps) {
  const [currentBundling, setCurrentBundling] = useState<BundlingContract | null>(null);
  const [isCurrentLoading, setIsCurrentLoading] = useState<boolean>(false);
  const [bundlings, setBundlings] = useState<BundlingContract[] | null>(null);
  const [isListLoading, setIsListLoading] = useState<boolean>(false);

  const dataValue: BundlingDataContextContract = useMemo(
    () => ({
      currentBundling,
      setCurrentBundling,
      isCurrentLoading,
      setIsCurrentLoading,
      bundlings,
      setBundlings,
      isListLoading,
      setIsListLoading,
    }),
    [
      currentBundling,
      isCurrentLoading,
      setCurrentBundling,
      setIsCurrentLoading,
      bundlings,
      isListLoading,
      setBundlings,
      setIsListLoading,
    ]
  );

  return <BundlingDataContext.Provider value={dataValue}>{children}</BundlingDataContext.Provider>;
}
